// build: 2026-08-27a (add-on <-> speaker link token; free add-on skip guard)
(() => {
  // One shape for both the grille row and the add-on row: "+ €205,00 sold as a pair".
  // Space after the plus, and no separator before the note.
  function formatMeta(price, note) {
    return note ? `+ ${price} ${note}` : `+ ${price}`;
  }

  const productAddons = document.querySelectorAll('.product-addon');

  // One token per page load, shared by the speaker line and any paid add-on
  // added with it. cart-addon-link.js uses it to keep the two in step: remove
  // the speakers and the add-on goes too; change the speaker quantity and the
  // add-on follows. Removing the add-on on its own leaves the speakers alone.
  const bundleToken = 'b' + Date.now().toString(36) + Math.random().toString(36).slice(2, 8);
  const bundleField = document.querySelector('[data-bundle-token]');
  if (bundleField) bundleField.value = bundleToken;

  productAddons.forEach((addonEl) => {
    // const addonId = addonEl.id;

    function updateAddonPrice() {
      const checked = addonEl.querySelector('.product-option__checkbox:checked');
      const meta = addonEl.querySelector('.block-label__meta');
      if (!checked || !meta) return;

      const price = checked.dataset.price;
      // "Included" rather than "€0,00" for the standard cable — and no pair note
      // against it, because there is no price for the pair to qualify.
      const isZero = Number((price || '').replace(/\D/g, '')) === 0;
      const note = meta.dataset.pairNote || '';

      meta.textContent = isZero ? 'Included' : formatMeta(price, note);
    }

    addonEl.querySelectorAll(`.product-option__checkbox`).forEach((radioEl) => {
      radioEl.addEventListener('change', function () {
        updateAddonPrice();
      });
    });

    updateAddonPrice();
  });

  // Variant options (e.g. Grille): show the price uplift next to the label — the same
  // treatment add-ons get — and keep the headline price in step with the chosen variant.
  const variantOption = document.querySelector('.product-variant-option');

  if (variantOption) {
    const priceAmountEl = document.querySelector('.product-price__amount');
    const priceFromEl = document.querySelector('.product-price__from');
    const metaEl = variantOption.querySelector('.block-label__meta');

    function updateVariantPrice(isUserChange) {
      const checked = variantOption.querySelector('.product-option__checkbox:checked');
      if (!checked) return;

      // Always assign — "No grille" has no uplift, so the label clears rather than
      // going stale or advertising a price against an option that does not carry one.
      if (metaEl) {
        const price = checked.dataset.price || '';
        metaEl.textContent = price ? formatMeta(price, metaEl.dataset.pairNote || '') : '';
      }

      if (priceAmountEl && checked.dataset.fullPrice) {
        priceAmountEl.textContent = checked.dataset.fullPrice;
        // Drop the "from" prefix once a grille has actively been chosen — the price is then exact.
        if (isUserChange && priceFromEl) priceFromEl.style.display = 'none';
      }
    }

    variantOption.querySelectorAll('.product-option__checkbox').forEach((radioEl) => {
      radioEl.addEventListener('change', () => updateVariantPrice(true));
    });

    updateVariantPrice(false);
  }

  document.querySelector('ajax-cart-product-form form').addEventListener('submit', (e) => {
    let addonsToAdd = [];

    productAddons.forEach((addonEl) => {
      const checked = addonEl.querySelector('.product-option__checkbox:checked');
      const selectedVariant = checked.value;
      // Only add a PAID add-on as its own line — skip the £0 "included" option (e.g. standard cable)
      const isFree = Number((checked.dataset.price || '').replace(/\D/g, '')) === 0;
      if (selectedVariant !== 'none' && !isFree) {
        // These go on as their own line items, so they miss the hidden
        // properties field on the main form and need it attaching here.
        // The wording comes from the markup rather than this file, so the
        // value names whatever the add-on actually is - "2 cables", not
        // "2 speakers". Empty means the add-on is not sold as a pair.
        const pairValue = addonEl.dataset.pairValue || '';
        addonsToAdd = [...addonsToAdd, { id: selectedVariant, pairValue }];
      }
    });

    if (!!addonsToAdd.length) {
      liquidAjaxCart.add({
        items: addonsToAdd.map(({ id, pairValue }) => {
          const item = { id, quantity: 1, properties: { _parent: bundleToken } };
          if (pairValue) {
            item.properties.Pair = pairValue;
          }
          return item;
        }),
      });
    }

    console.log({ addonsToAdd });
  });
})();
